/* global Detectizr */

// polyfills
import throttle from 'lodash/throttle'
import Store from 'core/Store'

import ScrollRaf from 'utilities/scrollRaf'

import ImageGrid from 'components/ImageGrid'
import Manufacturer from 'components/Manufacturer'
import MobileNav from 'components/MobileNav'

import { version } from '../package.json'

// redirect bad url right now

Store.set('breakpoint.desktop', 768)
Store.set('breakpoint.desktop.height', 470)

window.__version = version

let throttleSetup = setup
if (module.hot) { throttleSetup = function () { setTimeout(setup, 1) } }
if (window.polyfillLoaded) throttleSetup()
else window.onPolyFillLoaded = throttleSetup

function setup () {
  Store.watch('size', onResize)
  Store.set('env', null)

  // setup global resize event throught Store
  const debouncedResize = throttle(() => {
    Store.set('size', { w: window.innerWidth, h: window.innerHeight })
  }, 50)
  window.addEventListener('resize', debouncedResize)
  Store.set('size', { w: window.innerWidth, h: window.innerHeight })

  // The scroll event fires only once per frame
  const scrollRaf = ScrollRaf()
  scrollRaf.listen()

  initComponents()

  // refire resize event
  setTimeout(() => Store.set('size', Store.get('size')), 100)
  setTimeout(() => Store.set('size', Store.get('size')), 500)
  setTimeout(() => Store.set('size', Store.get('size')), 1000)
}

function initComponents () {
  const main = document.querySelector('main')
  if (main && main.classList.contains('page-home')) ImageGrid()

  const nav = document.querySelector('.header-nav-mobile')
  const button = document.querySelector('.button-nav-mobile')
  if (nav && button) MobileNav(nav, button, main)

  if (main && main.classList.contains('page-manufacturers')) {
    const $description = main.querySelector('.description')
    const $manufacturers = main.querySelectorAll('.manufacturers-list .manufacturer a')
    for (let i = 0; i < $manufacturers.length; i++) {
      Manufacturer($manufacturers[i], $description, $manufacturers)
    }
  }
}

function onResize (nSize) {
  let envMobile = false
  const deviceIsDesktop = !!(Detectizr.device.type === 'desktop')
  if (!deviceIsDesktop ||
    nSize.w <= Store.get('breakpoint.desktop') ||
    nSize.h <= Store.get('breakpoint.desktop.height')) {
    envMobile = true
  }

  if (envMobile && Store.get('env') !== 'mobile') {
    document.body.classList.add('mobile')
    Store.set('env', 'mobile')
  }

  if (!envMobile && Store.get('env') !== 'desktop') {
    document.body.classList.remove('mobile')
    Store.set('env', 'desktop')
  }
}



// WEBPACK FOOTER //
// ./src/app.js